var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},_vm._l((_vm.headers),function(item,index){return _c('el-table-column',{key:index,attrs:{"prop":item.key,"show-overflow-tooltip":true,"label":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }